import { render, staticRenderFns } from "./PageLogout.vue?vue&type=template&id=45baf948&"
import script from "./PageLogout.vue?vue&type=script&lang=js&"
export * from "./PageLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports